<template>
  <div class="flex flex-col gap-4">
    <div class="flex gap-2">
      <OrderTypeToggle :alert-user="true" :grand-total="grandTotal" />
    </div>

    <div
      v-if="diningOptionObject"
      id="delivery-schedule-section"
      class="bg-gray-50 p-5 rounded-2xl border border-gray-100 space-y-4"
      :class="{ 'border-red-400': errors.scheduledDay || errors.scheduledTime }"
    >
      <div
        class="flex items-center justify-between border-b pb-3 border-gray-200"
      >
        <span class="text-sm font-bold text-gray-500 uppercase tracking-wider">
          {{
            diningOptionObject.is_deliverable
              ? "Delivery Schedule & Location"
              : "Pickup Schedule"
          }}
        </span>
      </div>

      <div class="flex justify-between items-start">
        <div class="flex flex-col mr-4 flex-grow">
          <span class="text-xs text-gray-500 uppercase font-bold block mb-1">
            {{
              diningOptionObject.is_deliverable
                ? "Delivery Time"
                : "Pickup Time"
            }}
          </span>
          <span class="font-bold text-base text-gray-900">
            <span v-if="config.timing === 'asap'">
              ASAP (10-15m)
            </span>
            <span v-else-if="config.scheduledDay && config.scheduledTime">
              {{
                formatScheduledTime(config.scheduledDay, config.scheduledTime)
              }}
            </span>
            <span v-else class="text-gray-500">
              Not scheduled
            </span>
          </span>
          <p v-if="errors.scheduledTime" class="text-xs text-red-600 mt-1">
            {{ errors.scheduledTime }}
          </p>
          <p v-if="errors.scheduledDay" class="text-xs text-red-600 mt-1">
            {{ errors.scheduledDay }}
          </p>
        </div>

        <div class="flex-shrink-0">
          <Button
            @click="
              openDeliverySettingsModal({
                showAddress: false,
                showSchedule: true
              })
            "
            size="sm"
            variant="outline"
            custom-class="rounded-full bg-white px-4 py-2 font-bold shadow-sm"
          >
            Edit
          </Button>
        </div>
      </div>

      <div
        v-if="diningOptionObject.is_deliverable"
        class="pt-3 border-t border-gray-200 flex justify-between items-start"
      >
        <div class="mr-4 flex-grow">
          <span class="text-xs text-gray-500 uppercase font-bold block mb-2">
            Delivery Address
          </span>
          <div
            v-if="deliveryAddress && deliveryAddress.address_1"
            class="text-gray-900 font-medium text-sm"
          >
            <p class="font-semibold">{{ deliveryAddress.address_1 || "" }}</p>
            <p v-if="deliveryAddress.address_2" class="text-gray-700">
              {{ deliveryAddress.address_2 }}
            </p>
            <p class="text-gray-700">
              <span v-if="deliveryAddress.city">{{
                deliveryAddress.city
              }}</span>
              <span v-if="deliveryAddress.city && deliveryAddress.state"
                >,
              </span>
              <span v-if="deliveryAddress.state">{{
                deliveryAddress.state
              }}</span>
              <span v-if="deliveryAddress.postal_code">
                {{ deliveryAddress.postal_code }}</span
              >
            </p>
          </div>
          <div v-else>
            <span class="text-gray-500 text-sm italic"
              >No address provided</span
            >

            <p
              class="text-xs text-red-600 mt-2"
              v-if="diningOptionObject.is_deliverable && errors.deliveryAddress"
            >
              Delivery address is required. Please click **Update** to add your
              address.
            </p>
          </div>
        </div>

        <div class="flex-shrink-0">
          <Button
            @click="
              openDeliverySettingsModal({
                showAddress: true,
                showSchedule: false
              })
            "
            size="sm"
            variant="secondary"
          >
            Edit
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import OrderTypeToggle from "@/components/OrderTypeToggle.vue";
import Button from "@/components/ui/Button.vue";
import { useModalManagement } from "@/composables/useModalManagement";

export default {
  name: "OrderType",
  components: {
    OrderTypeToggle,
    Button
  },
  props: {
    grandTotal: {
      type: Number,
      default: 0
    },
    errors: {
      type: Object,
      default: () => {}
    }
  },
  created() {
    this._modalManagement = useModalManagement(this.$store);
  },
  computed: {
    ...mapGetters([
      "orderConfig",
      "getDiningOptionObject",
      "getDeliveryAddress",
      "getCurrencySymbol"
    ]),
    config() {
      return this.orderConfig;
    },
    diningOptionObject() {
      return this.getDiningOptionObject;
    },
    deliveryAddress() {
      return this.getDeliveryAddress;
    },
    currency() {
      return this.getCurrencySymbol || "$";
    }
  },
  methods: {
    ...mapActions(["openScheduleModal"]),

    openDeliverySettingsModal(
      options = { showAddress: true, showSchedule: true }
    ) {
      this._modalManagement.setScheduleModalOpen(true, options);
    },
    formatScheduledTime(day, time) {
      if (!day || !time) return "";
      const dayLabel =
        day === "Today" ? "Today" : day === "Tomorrow" ? "Tomorrow" : day;
      return `${dayLabel} at ${time}`;
    }
  }
};
</script>

<style></style>
